import GuestCheckoutJoinBI from 'components/RichProfile/MyAccount/OrderDetail/GuestCheckoutJoinBI/GuestCheckoutJoinBI.f';

export default GuestCheckoutJoinBI;
